export const isOnPatientPage = (pathname: string): boolean => {
  return pathname.startsWith('/patients/');
};
